const BRAND_CHOOVIE = "brand_choovie";
const BRAND_TOYOTA = "brand_toyota";
const BRAND_LEXUS = "brand_lexus";
const BRAND_BUDGET_DIRECT = "brand_budget_direct";
const BRAND_AUTO_AND_GENERAL = "brand_auto_and_general";
const BRAND_ORIGIN_ENERGY = "brand_origin_energy";
const BRAND_ROADSHOW_DIRECT = "brand_roadshow_direct";
const BRAND_CINEMA_NEAR_ME = "brand_cinema_near_me";
const BRAND_AIA = "brand_aia";
const BRAND_WBBL = "brand_wbbl";
const PLUS_MOVIES = "brand_plus_movies";

const BRAND_ZENITH = "brand_zenith";

const BRAND_WALT_DISNEY_DEADPOOL_WOLVERINE = "brand_walt_disney_deadpool_wolverine";

const BRAND_BUPA = "brand_bupa";

const BRAND_HOYTS_CINEMABENEFIT = "brand_hoyts_cinemabenefit";

const BRAND_CHOICE_HOTELS = "brand_choice_hotels";

const BRAND_LEXUS_VM = "brand_lexus_vm";

const BRAND_TELSTRA = "brand_telstra";

const BRAND_IGO_DIRECT = "brand_igo_direct";

const BRAND_MAGIC_BEACH = "brand_magic_beach";

const BRAND_TELSTRA_PLUS_MOVIES = "brand_telstra_plus_movies";

const BRAND_ENTERTAINMENT_MOVIES = "brand_entertainment_movies";

const BRAND_BIG_4_PERKS_PLUS_MOVIES = "brand_big_4_perks_plus_movies";

const BRAND_MALTESERS = "brand_maltesers";

const BRAND_CAMP_AUSTRALIA = "brand_camp_australia";

const BRAND_THEIR_CARE = "brand_their_care";

const BRAND_JAG = "brand_jag";

const BRAND_ENGIE = "brand_engie";

const BRAND_OLAY_WICKED_FOR_GOOD_MOVIE_TIX = "brand_olay_wicked_for_good_movie_tix";

const BRAND_WINK = "brand_wink";

export {
    BRAND_CHOOVIE,
    BRAND_TOYOTA,
    BRAND_LEXUS,
    BRAND_BUDGET_DIRECT,
    BRAND_AUTO_AND_GENERAL,
    BRAND_ORIGIN_ENERGY,
    BRAND_ROADSHOW_DIRECT,
    BRAND_CINEMA_NEAR_ME,
    BRAND_AIA,
    BRAND_WBBL,
    PLUS_MOVIES,
    BRAND_ZENITH,
    BRAND_WALT_DISNEY_DEADPOOL_WOLVERINE,
    BRAND_BUPA,
    BRAND_HOYTS_CINEMABENEFIT,
    BRAND_CHOICE_HOTELS,
    BRAND_LEXUS_VM,
    BRAND_IGO_DIRECT,
    BRAND_MAGIC_BEACH,
    BRAND_ENTERTAINMENT_MOVIES,
    BRAND_BIG_4_PERKS_PLUS_MOVIES,
    BRAND_MALTESERS,
    BRAND_CAMP_AUSTRALIA,
    BRAND_THEIR_CARE,
    BRAND_TELSTRA_PLUS_MOVIES,
    BRAND_TELSTRA,
    BRAND_JAG,
    BRAND_ENGIE,
    BRAND_OLAY_WICKED_FOR_GOOD_MOVIE_TIX,
    BRAND_WINK
};
